module.exports = __webpack_public_path__ + "assets/LogoS.876a4138a1f551779d35b16f1667fb84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/logo/LogoS.png
// module id = 755
// module chunks = 0